import { useEffect } from "react";
import useStyleStore from "src/stores/useStyleStore";

const useOverrideBackgroundColor = (color: string) => {
	useEffect(() => {
		const unsubscribe = useStyleStore.getState().overrideBackgroundColor(color);
		return () => {
			unsubscribe();
		};
	}, [color]);
};
export default useOverrideBackgroundColor;
